var _polyline, _path, _path2, _circle, _path3, _path4, _line, _line2, _line3, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "8 36 16 36 16 52 8 52"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 38h8a4 4 0 0 1 4 4h9a3 3 0 0 1 3 3 3 3 0 0 1-3 3H26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m40 44.8 6.63-4a5.82 5.82 0 0 1 3-.82 5.78 5.78 0 0 1 4.09 1.69L56 44 38.07 54.76A8.75 8.75 0 0 1 33.58 56a8.68 8.68 0 0 1-3.06-.56L16 50"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 22,
    r: 14
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.33 22a3.34 3.34 0 0 1 0-6.67"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.67 22a3.34 3.34 0 0 1 0 6.67"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 12,
    x2: 38,
    y2: 15.33
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 28.67,
    x2: 38,
    y2: 32
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 36.33,
    y1: 22,
    x2: 39.67,
    y2: 22
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43 17s-1.67-1.67-3.33-1.67h-3.34"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27s1.67 1.67 3.33 1.67h3.34"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarn);
export default __webpack_public_path__ + "static/media/earn.79c51f61cf58b9607878378af2c44845.svg";
export { ForwardRef as ReactComponent };